import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'
import Nprogress from 'nprogress';
import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    franchiseLogList: [],
    franchiseStatementList: [],
    franchisePaymentStatementList: [],
    franchisePaymentsList: [],
    franchiseDatas: [],
    commissionAccountDetails: [],
    payoutAccounts: [],
    paymentAccountDetails: [],
    userRenewalCommissionAccounts: [],
    franchiseConfigData: [],
    addLimitFlowDetailsList: [],
    franchiseAddLimitDetailsList: [],
    franchiseManageDatas: [],
    resellerPaymentIndexData: [],
    resellerBlockedList: [],
    allResellerDetailsData: [],
    resellerChargedData: [],
    subzonePackageData: []
}

const mutations = {
    CLEAR_FRANCHISE_STATE(state) {
        state.franchiseLogList = [];
        state.franchiseStatementList = [];
        state.franchisePaymentStatementList = [];
        state.franchisePaymentsList = [];
        state.franchiseDatas = [];
        state.commissionAccountDetails = [];
        state.payoutAccounts = [];
        state.paymentAccountDetails = [];
        state.userRenewalCommissionAccounts = [];
        state.franchiseConfigData = [];
        state.franchiseConfigSampleFilePath = "";
        state.franchiseManageDatas = [];
        state.resellerPaymentIndexData = [];
        state.resellerBlockedList = [];
        state.allResellerDetailsData = [];
        state.resellerChargedData = [];
    },
    SET_FRANCHISE_ADD_LIMIT_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.franchiseAddLimitDetailsList = [];
        if (parseData != null) {
            tData[userData.accountId + '-franchiseAddLimitDetailsList'] = parseData;
            state.franchiseAddLimitDetailsList = tData;
        }
    },
    SET_ADD_LIMIT_FLOW_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.addLimitFlowDetailsList = [];
        if (parseData != null) {
            tData[userData.accountId + '-addLimitFlowDetailsList'] = parseData;
            state.addLimitFlowDetailsList = tData;
        }
    },
    SET_FRANCHISE_LOG_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.franchiseLogList = [];
        if (parseData != null) {
            tData[userData.accountId + '-franchiseLogList'] = parseData;
            state.franchiseLogList = tData;
        }
    },
    SET_FRANCHISE_STATEMENT_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.franchiseStatementList = [];
        if (parseData != null) {
            tData[userData.accountId + '-franchiseStatementList'] = parseData;
            state.franchiseStatementList = tData;
        }
    },
    DEL_FRANCHISE_STATEMENT_LIST(state) {
        state.franchiseStatementList = [];
    },
    SET_FRANCHISE_PAYMENT_STATEMENT_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.franchisePaymentStatementList = [];
        if (parseData != null) {
            tData[userData.accountId + '-franchisePaymentStatementList'] = parseData;
            state.franchisePaymentStatementList = tData;
        }
    },
    SET_FRANCHISE_MANAGEMENT(state, data) {
        var tData = {};
        var tData2 = {};
        var tData3 = {};
        var tData4 = {};
        var tData5 = {};
        var tData6 = {};
        var table = null;
        if (data.table != undefined) {
            table = data.table;
        }

        var parseData = data.message;
        state.franchiseDatas = [];
        if (parseData != null) {
            tData6['permissions'] = parseData.permissions;
            tData6['enableResellerBilling'] = parseData.enableResellerBilling;
            tData6['thisAccountIsFranchiseTopAccount'] = parseData.thisAccountIsFranchiseTopAccount;
            tData6['commissionAccountPresent'] = parseData.commissionAccountPresent;
            state.franchiseManageDatas = tData6;
            if (table == "franchiseDatas" || table == null) {
                tData['franchiseDatas'] = parseData.franchiseDatas;
                state.franchiseDatas = tData;
            }
            if (table == "commissionAccountDetails") {
                tData2['commissionAccountDetails'] = parseData.commissionAccountDetails;
                state.commissionAccountDetails = tData2;
            }
            if (table == "payoutAccounts" || table == null) {
                tData3['payoutAccounts'] = parseData.payoutAccounts;
                state.payoutAccounts = tData3;
            }
            if (table == "paymentAccountDetails" || table == null) {
                tData4['paymentAccountDetails'] = parseData.paymentAccountDetails;
                state.paymentAccountDetails = tData4;
            }
            if (table == "userRenewalCommissionAccounts" || table == null) {
                tData5['userRenewalCommissionAccounts'] = parseData.userRenewalCommissionAccounts;
                state.userRenewalCommissionAccounts = tData5;
            }
        }
    },
    SET_FRANCHISE_PAYMENTS_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.franchisePaymentsList = [];
        if (parseData != null) {
            tData[userData.accountId + '-franchisePaymentsList'] = parseData;
            state.franchisePaymentsList = tData;
        }
    },
    UPDATE_FRANCHISE_PAYMENT_STATUS(state, data) {
        var id = data.id;
        var type = "Deleted";
        var comment = data.comment;
        var accountId = data.accountId;
        if (Object.keys(state.franchisePaymentsList).length != 0 && state.franchisePaymentsList != 'noData') {
            var index = state.franchisePaymentsList[accountId + "-franchisePaymentsList"].findIndex(payments => payments.FranchisePayments.id == id);
            if (index != -1) {
                state.franchisePaymentsList[accountId + '-franchisePaymentsList'][index].FranchisePayments.delete_payment = type;
                state.franchisePaymentsList[accountId + '-franchisePaymentsList'][index].FranchisePayments.comments = comment;
            }
        }
    },
    UPDATE_FRANCHISE_BALANCE_STATUS(state, data) {
        if (data.updateData.userRenewalCommissionAccounts != undefined) {
            var accountId = data.updateData.franchiseManagement.Account.id;
            var adminAccountId = data.updateData.userRenewalCommissionAccounts.AccountId;
            var adminUsername = data.updateData.userRenewalCommissionAccounts.userName;
            if (Object.keys(state.userRenewalCommissionAccounts).length != 0 && state.userRenewalCommissionAccounts != 'noData') {
                var index = state.userRenewalCommissionAccounts["userRenewalCommissionAccounts"].findIndex(datas => datas.AccountId == adminAccountId);
                if (index != -1) {
                    var index1 = state.userRenewalCommissionAccounts["userRenewalCommissionAccounts"][index]['admins'].findIndex(data => data.userName == adminUsername);
                    if (index1 != -1) {
                        state.userRenewalCommissionAccounts['userRenewalCommissionAccounts'][index]['admins'][index1]['balance'] = data.updateData.userRenewalCommissionAccounts.balance;
                        state.userRenewalCommissionAccounts['userRenewalCommissionAccounts'][index]['admins'][index1]['parentShare'] = data.updateData.userRenewalCommissionAccounts.parentShare;
                    }
                }
            }

        } else {
            var accountId = data.updateData.Account.id;
        }
        if (Object.keys(state.franchiseDatas).length != 0 && state.franchiseDatas != 'noData') {
            var index = state.franchiseDatas["franchiseDatas"].findIndex(datas => datas.Account.id == accountId);
            if (index != -1) {
                state.franchiseDatas['franchiseDatas'].splice(index, 1, data.updateData);

            }
        }
    },
    UPDATE_FRANCHISE_DATAS(state, data) {
        if (Object.keys(state.franchiseDatas).length != 0 && state.franchiseDatas != 'noData' && data.length > 0) {
            for (var i = 0; i < data.length; i++) {
                var index = state.franchiseDatas["franchiseDatas"].findIndex(datas => datas.account_id == data[i].account_id);
                if (index != -1) {
                    state.franchiseDatas['franchiseDatas'].splice(index, 1, data[i]);
                }
            }

        }
    },
    UPDATE_FRANCHISE_PAYOUT(state, data) {
        var accountId = data.updateData.AccountId;
        if (Object.keys(state.payoutAccounts).length != 0 && state.payoutAccounts != 'noData') {
            var index = state.payoutAccounts["payoutAccounts"].findIndex(datas => datas.AccountId == accountId);
            if (index != -1) {
                state.payoutAccounts['payoutAccounts'].splice(index, 1, data.updateData);
            }
        }
    },
    UPDATE_FRANCHISE_PAYMENT_ACCOUNT(state, data) {
        var accountId = data.updateData.account_id;
        if (Object.keys(state.paymentAccountDetails).length != 0 && state.paymentAccountDetails != 'noData') {
            var index = state.paymentAccountDetails["paymentAccountDetails"].findIndex(datas => datas.account_id == accountId);
            if (index != -1) {
                state.paymentAccountDetails['paymentAccountDetails'].splice(index, 1, data.updateData);
            }
        }
    },
    UPDATE_FRANCHISE_LOG_LIST(state, data) {
        var id = data.franchiseId;
        var type = (data.type != "" && data.type != null) ? ((data.type == "deactivated") ? "activate" : "deactivate") : "";
        var paymentStatus = data.returnCurrStatus;
        var accountId = data.accountId;
        if (Object.keys(state.franchiseLogList).length != 0 && state.franchiseLogList != 'noData') {
            var index = state.franchiseLogList[accountId + "-franchiseLogList"].findIndex(logs => logs.FranchiseManagement.id == id);
            if (index != -1) {
                state.franchiseLogList[accountId + '-franchiseLogList'][index].FranchiseManagement.activateDeactivate_button = type;
                state.franchiseLogList[accountId + '-franchiseLogList'][index].FranchiseManagement.status = paymentStatus;
            }
        }
    },
    SET_FRANCHISE_CONFIG_DATA(state, data) {
        state.franchiseConfigSampleFilePath = data.samplePath;
        state.franchiseConfigData = data;
    },
    SET_SUBZONE_PACKAGE_DATA(state, data) {
        state.subzonePackageData = data;
    },
    SINGLE_FRANCHISE_PACKAGE_DETAIL(state, data) {
        var index = state.subzonePackageData['profilesArr'].findIndex(
            (datas) => datas.account_id == data.accountId
        );
        if (index != -1) {
            state.subzonePackageData['profilesArr'].splice(index, 1, data['profilesArr'][0]);
        }
    },
    UPDATE_ADDITIONAL_FRANCHISE_CONFIG(state, data) {
        var parseData = data.additionalTaxes;
        Vue.set(state.franchiseConfigData.franchiseRevenue, 'additionalTaxes', parseData);
    },
    SET_RESELLER_PAYMENTINDEX_DATA(state, data) {
        state.resellerPaymentIndexData = data;
    },
    SET_RESELLER_BLOCKED_LIST(state, userData) {
        var tData = {};
        var parseData = userData.message;
        state.resellerBlockedList = [];
        if (parseData != null) {
            tData[userData.accountId + '-resellerBlockedList'] = parseData;
            state.resellerBlockedList = tData;
        }
    },
    SET_RESELLER_DETAILS(state, data) {
        state.allResellerDetailsData = data.message;
    },
    SET_RESELLER_CHARGE_DATA(state, data) {
        state.resellerChargedData = data
    },
    UPDATE_COMMISSION_DATAS(state, data) {
        if (Object.keys(state.commissionAccountDetails).length != 0 && state.commissionAccountDetails != 'noData' && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                var index = state.commissionAccountDetails['commissionAccountDetails'].findIndex(
                    (datas) => datas.AccountId == data[i].AccountId
                );
                if (index != -1) {
                    state.commissionAccountDetails['commissionAccountDetails'].splice(index, 1, data[i]);
                }
            }
        }
    },
}

const actions = {
    clearFranchiseState({
        commit,
        dispatch
    }) {
        commit('CLEAR_FRANCHISE_STATE')
    },
    getAllFranchiseInvoices({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get("/franchise_management/get_all_franchise_invoices/" +
                authData.status +
                "/" +
                authData.from +
                "/" +
                authData.to +
                "/" +
                authData.userId +
                "/" +
                true +
                "/" +
                authData.limit +
                "/" +
                authData.page +
                "/" +
                authData.search +
                "/" +
                authData.sorting)
                .then(res => {
                    Nprogress.done()
                    commit('SET_ADD_LIMIT_FLOW_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchFranchiseLogList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get("/franchise_management/franchise_data/" +
                authData.accountId +
                "/" +
                authData.customDateFrom +
                "/" +
                authData.customDateTo +
                "/" +
                true +
                "/" +
                authData.limitCount +
                "/" +
                authData.currentpage +
                "/" +
                authData.search +
                "/" +
                authData.sorting)
                .then(res => {
                    Nprogress.done()
                    commit('SET_FRANCHISE_LOG_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchFranchiseStatementList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get("/franchise_management/franchise_statement_data/" +
                authData.accountId +
                "/" +
                authData.customDateFrom +
                "/" +
                authData.customDateTo +
                "/" +
                true +
                "/" +
                authData.limit +
                "/" +
                authData.page +
                "/" +
                authData.search +
                "/" +
                authData.sorting)
                .then(res => {
                    Nprogress.done()
                    commit('SET_FRANCHISE_STATEMENT_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    getFranchiseAddLimit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/franchise_add_limit/' + null + '/true')
                .then(res => {
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    }
                    commit('SET_FRANCHISE_ADD_LIMIT_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    getFranchiseInvoiceDetailsSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/getInvoiceDetails', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    if (res.data.status != 'success') {
                        reject(res.data);
                    }
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });

    },
    operatorCallingSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.post(authData.operatorUrl, qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    if (res.data.status != 'success') {
                        reject(res.data);
                    }
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });

    },
    downloadFranchiseInvoiceSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/download_franchise_invoice', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    loader.hide();
                    if (res.data.status != 'success') {
                        reject(res.data);
                    } else {
                        window.open("/backend" + res.data.message, "_blank");
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });

    },
    makeFranchisePaySubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/add_limit_through_gateway', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    if (res.data.status != 'success-Payment') {
                        reject(res.data);
                    } else {
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });

    },
    fetchFranchiseStatement({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/franchise_statement/true')
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    clearFranchiseStatementList({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/clear_franchise_statement', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    if (res.data.status == 'success') {
                        commit('DEL_FRANCHISE_STATEMENT_LIST', res.data)
                    }
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });

    },
    fetchFranchisePaymentStatementList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get("/franchise_management/franchise_payment_statement_data/" +
                authData.accountId +
                "/" +
                authData.customDateFrom +
                "/" +
                authData.customDateTo +
                "/" +
                true +
                "/" +
                authData.limit +
                "/" +
                authData.page +
                "/" +
                authData.search +
                "/" +
                authData.sorting)
                .then(res => {
                    Nprogress.done()
                    commit('SET_FRANCHISE_PAYMENT_STATEMENT_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchFranchisePaymentStatement({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/franchise_payment_statement/true')
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchFranchisePayments({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/franchise_payments/true')
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchFranchisePaymentsList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get("/franchise_management/franchise_payment_data/" +
                authData.accountId +
                "/" +
                authData.customDateFrom +
                "/" +
                authData.customDateTo +
                "/" +
                true +
                "/" +
                authData.limit +
                "/" +
                authData.page +
                "/" +
                authData.search +
                "/" +
                authData.sorting)
                .then(res => {
                    Nprogress.done()
                    commit('SET_FRANCHISE_PAYMENTS_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    deleteFranchisePayment({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/FranchiseManagement/delete_franchise_payment', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != 'success') {
                    reject(response.data.message);
                    return;
                }
                var successData = {
                    id: postData.id,
                    comment: postData.notes,
                    accountId: response.data.accountId
                }
                commit('UPDATE_FRANCHISE_PAYMENT_STATUS', successData);
                resolve(response.data);
            })
                .catch(error => console.log(error));
        });
    },
    fetchFranchiseManagement({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/index/true')
                .then(res => {
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit('SET_FRANCHISE_MANAGEMENT', res.data);
                        resolve(res.data);
                    }

                })
                .catch(error => console.log(error))
        });
    },
    fetchFranchiseManagementDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/get_franchise_management_details/' + authData.table + '/' + true + '/' + authData.limit + '/' + authData.page + '/' + authData.search + '/' + authData.sorting)
                .then(res => {
                    Nprogress.done()
                    var data = res.data;
                    data['table'] = authData.table;
                    commit('SET_FRANCHISE_MANAGEMENT', data);
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchGetMonthlyRevenueStatus({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/getMonthlyRevenueStatus', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(res => {
                    Nprogress.done()
                    var data = res.data.message;
                    commit('UPDATE_FRANCHISE_DATAS', data);
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    generateFranchiseInvoice({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/generate_invoice_for_franchise', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != 'success') {
                    reject(response.data.message);
                    return;
                }
                resolve(response.data);
            })
                .catch(error => console.log(error));
        });
    },
    addLimitSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/add_limit', qs.stringify(postData, {
                parseArrays: false
            })).then(res => {
                loader.hide()
                var response = res.data;
                if (response.status == 'success-Payment') {

                    if (response.isRedirectFlag == "yes") {
                        window.location.href = response.message;
                    } else {
                        if (response.operator === "paytm") {
                            //$('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#paytmForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#paytmForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.paytmForm.submit();
                        } else if (response.operator === "traknpay") {
                            //$('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#traknpayForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#traknpayForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.traknpayForm.submit();
                        } else if (response.operator === "swiftpay") {
                            //$('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#swiftpayForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#swiftpayForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.swiftpayForm.submit();
                        } else if (response.operator === "aggrepay") {
                            //$('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#aggrepayForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#aggrepayForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.aggrepayForm.submit();
                        } else if (response.operator === "jazzcash") {
                            //$('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#jazzCashForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#jazzCashForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.jazzCashForm.submit();
                        } else if (response.operator === "ebs") {
                            //$('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#ebsForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#ebsForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.ebsForm.submit();
                        } else if (response.operator === "ccavenue") {
                            console.log(response.operator);
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#ccavenueForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#ccavenueForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.ccavenueForm.submit();
                        } else if (response.operator === "simplepay") {
                            function processPayment(token, paid) {
                                var txnid = response.message.txnid;
                                var sp_amount = SimplePay.amountToLower(response.message.amount);
                                window.location.href = '/franchise_management/franchise_add_limit/simplepay?&sp_token=' + token + '&sp_status=' + paid + '&sp_amount=' + sp_amount + '&txnid=' + txnid;
                            }
                            var handler = SimplePay.configure({
                                token: processPayment,
                                key: response.message.publicKey, // put you public key here
                                image: '' // put your logo here (please note you need to put a public web url)
                            });
                            handler.open(SimplePay.CHECKOUT,
                                {
                                    email: response.message.email,
                                    phone: response.message.phone,
                                    description: response.message.description,
                                    address: response.message.address,
                                    postal_code: response.message.postal_code,
                                    city: response.message.city,
                                    country: response.message.country,
                                    amount: SimplePay.amountToLower(response.message.amount),
                                    currency: response.message.currency
                                });
                        } else if (response.operator === "avantgarde") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#avantgardeForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#avantgardeForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.avantgardeForm.submit();
                        } else if (response.operator === "billdesk") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);

                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#billdeskForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#billdeskForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.billdeskForm.submit();
                        } else if (response.operator === "gtpay") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);
                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#gtpayForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#gtpayForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.gtpayForm.submit();
                        } else if (response.operator === "razorpay") {
                            $('#makePaymentModal').modal('hide');
                            var options = {
                                "key": response.message.keyId,
                                "amount": response.message.amount,
                                "name": response.message.business_name,
                                "description": response.message.description,
                                // "image": "/your_logo.png",
                                "handler": function (response) {
                                    console.log(response);
                                    //                                    window.location.href = '/franchise_management/franchise_add_limit/razorpay?&razorpay_payment_id=' + response.razorpay_payment_id + '&razorpay_order_id=' + response.razorpay_order_id + '&razorpay_signature=' + response.razorpay_signature;
                                    var f = document.createElement('form');
                                    f.action = '/franchise_management/franchise_add_limit/razorpay';
                                    f.method = 'POST';
                                    var i = document.createElement('input');
                                    i.type = 'hidden';
                                    i.name = 'razorpay_payment_id';
                                    i.value = response.razorpay_payment_id;
                                    f.appendChild(i);

                                    var j = document.createElement('input');
                                    j.type = 'hidden';
                                    j.name = 'razorpay_order_id';
                                    j.value = response.razorpay_order_id;
                                    f.appendChild(j);

                                    var k = document.createElement('input');
                                    k.type = 'hidden';
                                    k.name = 'razorpay_signature';
                                    k.value = response.razorpay_signature;
                                    f.appendChild(k);

                                    document.body.appendChild(f);
                                    f.submit();
                                },
                                "prefill": {
                                    "name": response.message.name,
                                    "email": response.message.email,
                                    "contact": response.message.contact
                                },
                                "notes": {
                                },
                                "theme": {
                                    "color": "#3498DB"
                                },
                                "modal": {
                                    "escape": false,
                                    "ondismiss": function () {

                                    }
                                },
                                "order_id": response.message.orderId
                            };
                            var rzp1 = new Razorpay(options);
                            rzp1.open();
                        } else if (response.operator === "esewa") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);
                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#esewaForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#esewaForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.esewaForm.submit();
                        } else if (response.operator === "federalbank") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);
                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#federalbankForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#federalbankForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.federalbankForm.submit();
                        } else if (response.operator === "worldline") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);
                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return { name: index, value: value };
                            });
                            $("#worldlineForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#worldlineForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.worldlineForm.submit();
                        } else if (response.operator === "swipez") {
                            $('#makePaymentModal').modal('hide');
                            var jsonText = response.message;
                            var jsonObj = JSON.parse(jsonText);
                            var jsonArray = $.map(jsonObj, function (value, index) {
                                return {
                                    name: index,
                                    value: value
                                };
                            });
                            $("#swipezForm").attr("action", response.redirectURL);
                            for (var i = 0; i < jsonArray.length; i++) {
                                $("#swipezForm").append('<input type="hidden" name="' + jsonArray[i].name + '" value="' + jsonArray[i].value + '">');
                            }
                            document.swipezForm.submit();
                        }
                    }
                }
                if (response.status == 'error-Payment') {
                    reject(res.data.message);
                    return;
                }
                if (res.data.status != 'success') {
                    reject(res.data.message);
                    return;
                }
                commit('UPDATE_FRANCHISE_BALANCE_STATUS', res.data);
                resolve(res.data);
            })
                .catch(error => console.log(error));
        });
    },
    reduceLimitSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/reduce_limit', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != 'success') {
                    reject(response.data.message);
                    return;
                }
                commit('UPDATE_FRANCHISE_BALANCE_STATUS', response.data);
                resolve(response.data);
            })
                .catch(error => console.log(error));
        });
    },
    payoutModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/add_payout_amount', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != 'success') {
                    reject(response.data.message);
                    return;
                }
                commit('UPDATE_FRANCHISE_PAYOUT', response.data);
                resolve(response.data);
            })
                .catch(error => console.log(error));
        });
    },
    paymentAccountSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/makePaymentFlow2', qs.stringify(postData, {
                parseArrays: false
            })).then(response => {
                loader.hide()
                if (response.data.status != 'success') {
                    reject(response.data.message);
                    return;
                }
                commit('UPDATE_FRANCHISE_PAYMENT_ACCOUNT', response.data);
                resolve(response.data);
            })
                .catch(error => console.log(error));
        });
    },

    fetchViewUserRevenue({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/view_user_revenue/true')
                .then(res => {
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    activateDeactivateSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/FranchiseManagement/activateDeactivate', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        franchiseId: response.data.franchiseId,
                        type: response.data.type,
                        returnCurrStatus: response.data.returnCurrStatus,
                        accountId: response.data.accountId
                    }
                    commit('UPDATE_FRANCHISE_LOG_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchFranchiseConfigData({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            var url = '/franchise_management/franchise_config_vue/' + authData.data + '/true';
            if (authData.fromWhere == 'dashboard') {
                url = '/dashboard/franchise_sub_config/' + authData.data + '/null/true';
            }
            axios.get(url)
                .then(res => {
                    loader.hide();
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    }
                    resolve(res.data);
                    commit('SET_FRANCHISE_CONFIG_DATA', res.data.message);

                })
                .catch(error => console.log(error))
        });
    },
    fetchSubzonePackageData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/franchise_package_details', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(res => {
                    loader.hide();
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    }
                    resolve(res.data);
                    commit('SET_SUBZONE_PACKAGE_DATA', res.data.message);

                })
                .catch(error => console.log(error))
        });
    },
    addFieldsSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/add_tax_field', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('UPDATE_ADDITIONAL_FRANCHISE_CONFIG', response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteFieldsSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/delete_tax_field', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'Success') {
                        reject(response.data.message);
                        return;
                    }
                    commit('UPDATE_ADDITIONAL_FRANCHISE_CONFIG', response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    importFranchiseConfigModal({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/franchise_config_settings_submit', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    franchiseConfigSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/franchise_config_settings_submit', postData)
                .then(response => {
                    loader.hide()

                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                    if (typeof response.data.vueData != "undefined" && response.data.vueData != null && response.data.vueData != [] && Object.keys(response.data.vueData).length > 0 && typeof response.data.vueData.message != 'undefined') {
                        commit('SET_FRANCHISE_CONFIG_DATA', response.data.vueData.message);
                    }


                })
                .catch(error => console.log(error));
        });
    },
    getOtherConfigDatasFetch({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/franchise_other_config', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    franchiseConfigOtherSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/franchise_other_config_settings_submit', postData)
                .then(response => {
                    loader.hide()

                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                    if (typeof response.data.vueData != "undefined" && response.data.vueData != null && response.data.vueData != [] && Object.keys(response.data.vueData).length > 0 && typeof response.data.vueData.message != 'undefined') {
                        commit('SET_FRANCHISE_CONFIG_DATA', response.data.vueData.message);
                    }


                })
                .catch(error => console.log(error));
        });
    },
    franchisePackageDetailSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/franchise_package_details_submit', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()

                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    franchiseEditProductSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/save_override_billing_products', postData)
                .then(response => {
                    loader.hide()
                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                    if (response.data.fromPackage == "yes") {
                        commit('SINGLE_FRANCHISE_PACKAGE_DETAIL', response.data.vueData);
                    } else {
                        if(response.data.tableType =='ISP'){
                            commit('SET_FRANCHISE_CONFIG_DATA', response.data.vueData.message);
                        }
                    }


                })
                .catch(error => console.log(error));
        });
    },
    franchiseOverrideShareSubzoneSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/save_franchise_share_subzone_from_package', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status == "redirect") {
                        router.push(response.data.message);
                    } else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchResellerPaymentlistData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/reseller_payment_index_list', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    if (response.data.status == 'redirect') {
                        window.location.href = response.data.message;
                        return;
                    }
                    commit("SET_RESELLER_PAYMENTINDEX_DATA", response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    updateResellerDetail({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/update_reseller_details', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    resellerPayLink({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/reseller_pay_now_link', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(res => {
                    if (res.data.status != 'success-Payment') {
                        reject(res.data);
                    } else {
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });
    },
    getResellerBlockedDetails({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/franchise_management/resellerBlocked')
                .then(res => {
                    Nprogress.done()
                    commit('SET_RESELLER_BLOCKED_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    resellerUnblocklist({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/resellerUnblock_list/' + postData.id + "/" + postData.status)
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    resellerFieldNameSave({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/franchise_management/update_reseller_billing_details', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchResellerAccountData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/reseller_account_detail', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    if (response.data.status == 'redirect') {
                        window.location.href = response.data.message;
                        return;
                    }
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    commit("SET_RESELLER_DETAILS", response.data)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    resellerChangeFetch({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/resellerCharges_data_list', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    commit("SET_RESELLER_CHARGE_DATA", response.data)
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },

    fetchRemainingCommissionData({
        commit,
        dispatch
    }, postData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/franchise_management/getRemainingCommissionAccData', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(res => {
                    Nprogress.done()
                    var data = res.data.message;
                    commit('UPDATE_COMMISSION_DATAS', data);
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },

}

const getters = {
    franchiseAddLimitDetailsGetter: state => {
        return state.franchiseAddLimitDetailsList;
    },
    addLimitFlowDetailsGetter: state => {
        return state.addLimitFlowDetailsList;
    },
    getFranchiseLogListGetters: state => {
        return state.franchiseLogList;
    },
    getFranchiseStatementListGetters: state => {
        return state.franchiseStatementList;
    },
    getFranchisePaymentStatementListGetters: state => {
        return state.franchisePaymentStatementList;
    },
    getFranchisePaymentsListGetters: state => {
        return state.franchisePaymentsList;
    },
    franchiseDatasGetter: state => {
        return state.franchiseDatas;
    },
    franchiseManageDatasGetter: state => {
        return state.franchiseManageDatas;
    },
    allResellerAccountDataGetters: state => {
        return state.allResellerDetailsData;
    },
    commissionAccountDetailsGetter: state => {
        return state.commissionAccountDetails;
    },
    payoutAccountsGetter: state => {
        return state.payoutAccounts;
    },
    paymentAccountDetailsGetter: state => {
        return state.paymentAccountDetails;
    },
    userRenewalCommissionAccountsGetter: state => {
        return state.userRenewalCommissionAccounts;
    },
    franchiseConfigDataGetter: state => {
        return state.franchiseConfigData;
    },
    getFranchiseConfigSampleFilePath: state => {
        return state.franchiseConfigSampleFilePath;
    },
    resellerPaymentIndexListGetters: state => {
        return state.resellerPaymentIndexData;
    },
    resellerChargesDataListGetters: state => {
        return state.resellerChargedData;
    },
    subzonePackageDataGetter: state => {
        return state.subzonePackageData;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
